import React, { useState } from 'react';
import api from '../utils/api';
import { formatDate } from '../utils/helpers';
import WordEditButton from './WordEditButton';

// Вкладка «Файлы»: «Наши документы» (папки, статусы «Ждём ответа»/«Выполнено») и «От клиента».
// Общая для гражданских дел и клиентов по банкротству — отличаются только адреса API (пропсы).
export default function FilesPanel({ files, loadFiles, showToast, uploadUrl, fieldName = 'files', fileHref, update, remove, toLegal, editType }) {
  const [uploading, setUploading] = useState(false);
  const [openFolder, setOpenFolder] = useState(null);
  const [fileMenu, setFileMenu] = useState(null);
  // загрузка по одному файлу: нет лимита на количество, ошибка одного не мешает остальным
  const uploadInput = (kind, folder) => (
    <input type="file" multiple style={{ display: 'none' }} accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp,.doc,.docx,.xls,.xlsx,.txt,.mp3,.m4a,.ogg,.oga,.opus,.wav,.amr,.aac,.3gp,image/*,audio/*" disabled={!!uploading} onChange={async e => {
      const list = Array.from(e.target.files || []);
      if (!list.length) return;
      const failed = [];
      for (let i = 0; i < list.length; i++) {
        setUploading({ kind, folder, text: `${i + 1} из ${list.length}` });
        const fd = new FormData();
        fd.append(fieldName, list[i]);
        try { await api.post(uploadUrl(kind, folder), fd); }
        catch (er) {
          const msg = er.response?.status === 413 ? 'файл больше 100 МБ' : (er.response?.data?.error || 'ошибка загрузки');
          failed.push(`${list[i].name}: ${msg}`);
        }
      }
      setUploading(false); e.target.value = ''; loadFiles();
      if (failed.length) showToast(`Загружено ${list.length - failed.length} из ${list.length}. Не загрузились: ${failed.join('; ')}`, 'error');
      else showToast(list.length > 1 ? `Загружено файлов: ${list.length}` : 'Файл загружен');
    }} />
  );
  const busy = (kind, folder) => uploading && uploading.kind === kind && (uploading.folder || null) === (folder || null);
  const clientFiles = files.filter(f => (f.kind || 'client') !== 'ours');
  const ours = files.filter(f => f.kind === 'ours');
  const NONE = 'Без папки';
  const groups = ours.reduce((g, f) => { const k = f.folder || NONE; (g[k] = g[k] || []).push(f); return g; }, {});
  const folderNames = Object.keys(groups).sort((a, b) => (a === NONE) - (b === NONE) || (a === 'Для клиента') - (b === 'Для клиента') || a.localeCompare(b, 'ru'));
  if (openFolder && !groups[openFolder]) folderNames.push(openFolder); // новая пустая папка
  const move = (f, patch) => { setFileMenu(null); update(f, patch).then(loadFiles); };
  const newFolder = cb => { const n = (window.prompt('Название папки (орган / адресат):') || '').trim(); if (n) cb(n.slice(0, 120)); };
  const STATUS = { sent: { label: 'Ждём ответа', color: '#d97706', bg: 'rgba(245,158,11,.12)' }, done: { label: 'Выполнено', color: '#16a34a', bg: 'rgba(22,163,74,.12)' } };
  const folderStatus = list => !list.length ? null : list.some(f => f.status === 'sent') ? 'sent' : list.every(f => f.status === 'done') ? 'done' : null;
  const setStatus = (f, status) => move(f, { status });
  const FileRow = ({ f }) => (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '8px 0', borderTop: '1px solid var(--border)', flexWrap: 'wrap', position: 'relative' }}>
      <a href={fileHref(f)} target="_blank" rel="noreferrer" style={{ flex: 1, minWidth: 200, fontSize: 14 }}>{f.original_name}</a>
      {f.kind === 'ours' && (
        <span style={{ display: 'flex', gap: 4 }}>
          {Object.entries(STATUS).map(([k, st]) => (
            <button key={k} title={f.status === k && f.status_date ? `с ${formatDate(f.status_date)}` : ''} onClick={() => setStatus(f, f.status === k ? null : k)}
              style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, cursor: 'pointer', border: `1px solid ${f.status === k ? st.color : 'var(--border)'}`, background: f.status === k ? st.bg : 'transparent', color: f.status === k ? st.color : 'var(--text-muted)', fontWeight: f.status === k ? 600 : 400 }}>
              {f.status === k ? '● ' : ''}{st.label}{f.status === k && f.status_date ? ` ${formatDate(f.status_date)}` : ''}
            </button>
          ))}
          {f.status && (
            <button title="Снять статус — документ ещё не отправлен/не сделан" onClick={() => setStatus(f, null)}
              style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, cursor: 'pointer', border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-muted)' }}>
              ↺ Не сделано
            </button>
          )}
        </span>
      )}
      <span style={{ fontSize: 12, color: 'var(--text-muted)', minWidth: 70 }}>{f.size ? Math.max(1, Math.round(f.size / 1024)) + ' КБ' : ''}</span>
      <span style={{ fontSize: 12, color: 'var(--text-muted)', minWidth: 80 }}>{formatDate(f.created_at)}</span>
      {editType && <WordEditButton type={editType} f={f} showToast={showToast} />}
      <a className="btn btn-secondary btn-sm" href={fileHref(f) + '?download=1'}>Скачать</a>
      <button className="btn btn-secondary btn-sm" title="Ещё" onClick={() => setFileMenu(fileMenu === f.id ? null : f.id)}>⋯</button>
      {fileMenu === f.id && (
        <div className="card" style={{ position: 'absolute', right: 0, top: '100%', zIndex: 30, padding: 6, minWidth: 240, boxShadow: '0 6px 20px rgba(0,0,0,.15)' }}>
          {f.kind === 'ours' ? <>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', padding: '4px 8px' }}>Переместить в папку</div>
            {folderNames.filter(n => n !== (f.folder || NONE) && n !== NONE).map(n => (
              <div key={n} className="menu-item" style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => move(f, { folder: n })}>{n}</div>
            ))}
            <div style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => newFolder(n => move(f, { folder: n }))}>+ Новая папка…</div>
            <div style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13, borderTop: '1px solid var(--border)' }} onClick={() => move(f, { kind: 'client' })}>Это файл клиента</div>
          </> : <>
            <div style={{ fontSize: 11, color: 'var(--text-muted)', padding: '4px 8px' }}>Это наш документ — в папку</div>
            {folderNames.filter(n => n !== NONE).map(n => (
              <div key={n} style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => move(f, { kind: 'ours', folder: n })}>{n}</div>
            ))}
            <div style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13 }} onClick={() => newFolder(n => move(f, { kind: 'ours', folder: n }))}>+ Новая папка…</div>
          </>}
          <div style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13, borderTop: '1px solid var(--border)' }} onClick={() => {
            setFileMenu(null);
            const folder = (window.prompt('Копия в «Правовую базу». Папка (например: Земля, Банкротство, Семья):', '') || '').trim();
            if (!folder) return;
            const subfolder = (window.prompt('Подпапка (необязательно):', '') || '').trim();
            toLegal(f, { folder, subfolder }).then(() => showToast('Скопировано в «Правовую базу»')).catch(e => showToast(e.response?.data?.error || 'Не удалось скопировать', 'error'));
          }}>📚 В правовую базу</div>
          <div style={{ padding: '6px 8px', cursor: 'pointer', fontSize: 13, color: 'var(--red)', borderTop: '1px solid var(--border)' }} onClick={() => { setFileMenu(null); if (window.confirm(`Удалить файл «${f.original_name}»?`)) remove(f).then(loadFiles); }}>Удалить</div>
        </div>
      )}
    </div>
  );
  return (
    <div className="card" style={{ padding: 20 }}>
      <div className="section-title" style={{ marginBottom: 8 }}>Наши документы <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>· {ours.length}</span></div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(170px,1fr))', gap: 10, marginBottom: 12 }}>
        {folderNames.map(n => {
          const on = openFolder === n;
          const list = groups[n] || [];
          const st = STATUS[folderStatus(list)];
          const cnt = k => list.filter(f => f.status === k).length;
          return (
            <div key={n} onClick={() => setOpenFolder(on ? null : n)} style={{ cursor: 'pointer', padding: '12px 14px', borderRadius: 10, border: `1px solid ${on ? 'var(--accent)' : st ? st.color : 'var(--border)'}`, borderLeft: st ? `4px solid ${st.color}` : undefined, background: on ? 'var(--bg-hover)' : st ? st.bg : 'transparent' }}>
              <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.3 }}>{n}</div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
                {list.length} док.
                {cnt('sent') > 0 && <span style={{ color: STATUS.sent.color, fontWeight: 600 }}> · ждём ответа {cnt('sent')}</span>}
                {cnt('done') > 0 && <span style={{ color: STATUS.done.color, fontWeight: 600 }}> · выполнено {cnt('done')}</span>}
              </div>
            </div>
          );
        })}
        <div onClick={() => newFolder(n => setOpenFolder(n))} style={{ cursor: 'pointer', padding: '12px 14px', borderRadius: 10, border: '1px dashed var(--border)', color: 'var(--text-muted)', fontSize: 14, display: 'flex', alignItems: 'center' }}>+ Новая папка</div>
      </div>
      {openFolder ? (
        <div style={{ border: '1px solid var(--border)', borderRadius: 10, padding: '12px 14px', marginBottom: 20 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 6 }}>
            <div style={{ fontSize: 15, fontWeight: 700 }}>{openFolder}</div>
            <label className="btn btn-primary btn-sm" style={{ cursor: uploading ? 'wait' : 'pointer' }}>
              {busy('ours', openFolder === NONE ? null : openFolder) ? `Загрузка ${uploading.text}…` : '+ Загрузить сюда'}
              {uploadInput('ours', openFolder === NONE ? null : openFolder)}
            </label>
          </div>
          {(groups[openFolder] || []).length === 0 && <div style={{ fontSize: 13, color: 'var(--text-muted)', padding: '8px 0' }}>Папка пустая — загрузите документ</div>}
          {(groups[openFolder] || []).map(f => <React.Fragment key={f.id}>{FileRow({ f })}</React.Fragment>)}
        </div>
      ) : (
        <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20 }}>{ours.length ? 'Нажмите на папку, чтобы открыть документы.' : 'Создайте папку органа и загрузите в неё документ.'}</div>
      )}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 4 }}>
        <div className="section-title">От клиента <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>· {clientFiles.length}</span></div>
        <label className="btn btn-primary btn-sm" style={{ cursor: uploading ? 'wait' : 'pointer' }}>
          {busy('client', null) ? `Загрузка ${uploading.text}…` : '+ Файлы от клиента'}
          {uploadInput('client', null)}
        </label>
      </div>
      <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 6 }}>PDF, фото, Word, Excel, аудиозаписи — до 100 МБ каждый, количество не ограничено. Файлы доступны только после входа в CRM.</div>
      {clientFiles.length === 0 && <div style={{ fontSize: 13, color: 'var(--text-muted)', padding: '8px 0', borderTop: '1px solid var(--border)' }}>Пусто</div>}
      {clientFiles.map(f => <React.Fragment key={f.id}>{FileRow({ f })}</React.Fragment>)}
    </div>
  );
      
}
